import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
    data: null,
    loading: false,
    error: null,
    count: null,
};

export const fetchAgenticInterviewList = createAsyncThunk(
    "fetchAgenticInterviewList",
    async (body) => {
        try {
            const response = await instance.get(
                `/remark/agentic/fetch-agentic-interview?page=${body.page}&search=${body.search}&startDate=${body.startDate}&endDate=${body.endDate}&status=${body.status}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);


export const AgenticInterviewSlice = createSlice({
    name: "AgenticInterviewSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchAgenticInterviewList.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(fetchAgenticInterviewList.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.count = action.payload?.count;


        });
        builder.addCase(fetchAgenticInterviewList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export default AgenticInterviewSlice.reducer;
